import { Component, Input, OnInit } from '@angular/core';

import { PersistentNavRoutes } from '../models/persistent-navigation.interface';

@Component({
	selector: 'mb-persistent-navigation',
	templateUrl: './persistent-navigation.component.html',
	styleUrls: ['./persistent-navigation.component.scss']
})
export class PersistentNavigationComponent implements OnInit {

	@Input() public routesList: PersistentNavRoutes[];
	public title: string;
	public showDropdown: boolean = false;

	public ngOnInit(): void {
		this.title = this.routesList[0]?.text?.dcrValue;
	}

	public changeDropdownTitle(link: PersistentNavRoutes): void {
		this.title = link.text.dcrValue;
	}
}
